
export enum UserNotificationType {
    CONTACTREQUEST = "contact_request",
    CONTACTREQUESTACCEPTED = "contact_request_accepted",
    MESSAGE = "message",
    LABUSERREQUEST = "lab_user_request",
}